<template>
    <div class="name_query">
        <div class="query_title">
          纺织品成分标准名称查询
        </div>
        <div class="query_content">
          <div>
            <el-autocomplete
                v-model="SearchValue"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入纺织品纤维名称/标准术语/俗称"
                @select="ChangeHotText"
                style="width: 541px;"
            >
              <template slot-scope="{item}">
                 <span v-html="item.name"></span>
              </template>
            </el-autocomplete>
          </div>
          <div>
            <el-button @click="SearchBtn" class="search_btn">查询</el-button>
          </div>
        </div>
      <div class="query_history" v-if="HistoryList.length">
         <div class="history_title">
           <span>历史查询：</span>
         </div>
          <div class="history_box">
              <div v-for="(item,index) in HistoryList" :key="index" class="his_word" @click="GetLocalHistoryData(item)">
                {{item.name}}
              </div>
          </div>
      </div>
      <div class="query_table">
        <el-table
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{background:'#F6F6F6'}"
            empty-text="无数据"
        >
          <el-table-column
              prop="componentName"
              label="中国标准术语"
              width="180" align="center">
            <template slot-scope="scope">
              <span v-html="scope.row.componentName"></span>
            </template>
          </el-table-column>
          <el-table-column
              prop="componentNameEn"
              label="国标英文术语" align="center">
            <template slot-scope="scope">
              <span v-html="scope.row.componentNameEn"></span>
            </template>
          </el-table-column>
          <el-table-column
              prop="componentNameUsa"
              label="美国标准术语" align="center">
            <template slot-scope="scope">
              <span v-html="scope.row.componentNameUsa"></span>
            </template>
          </el-table-column>
          <el-table-column
              prop="componentNameEur"
              label="欧盟标准术语" align="center">
            <template slot-scope="scope">
              <span v-html="scope.row.componentNameEur"></span>
            </template>
          </el-table-column>
          <el-table-column
              prop="commonlyName"
              label="俗称" align="center">
            <template slot-scope="scope">
              <span v-html="scope.row.commonlyName"></span>
            </template>
          </el-table-column>
          <el-table-column
              prop="componentType"
              label="所属分类" width="176px" align="center">
          </el-table-column>

        </el-table>
      </div>
    </div>
</template>

<script>
import {SearchComponent,SearchFastFeek} from "src/request/apis";
import  {Debounce}  from "src/utils";
export default {
  name: "TicNameQuery",
  props:{
    apiHost: {
      type: String,
      default: ()=>''
    },
    JumpPersonalCenter:{
      type: String,
      default: ()=>''
    },
  },
  data(){
    return {
      hotList: [],
      loading: false,
      SearchValue:'',
      HistoryList:[],
      tableData: []
    }
  },
  created() {
    this.SearchBtn(0)
    this.GetHistoryList()
  },
  mounted(){
    this.hotList = [];
  },
  methods:{
    querySearchAsync(queryString, cb){
      if(queryString !==''){
        this.loading=true
        this.SearchValue=queryString
        this.SearchListData(cb)
      }else{
        cb([])
      }
    },
    SearchListData: Debounce(function (cb) {
      if(this.SearchValue){
        SearchFastFeek({
          name:this.SearchValue
        },this.apiHost).then(res=>{
          this.hotList=res.data.items
          this.hotList.forEach(val=>{
            val.value=val.name
          })
          if(this.hotList.length>0){
            cb(this.hotList)
          }else{
            cb([{
              id:'-1',
              name:'未检索到相关结果'
            }])
          }

          this.loading=false
        }).catch(err=>{
          if(err.resultCode==='6001'){
            this.$router.push({
              path:this.JumpPersonalCenter
            })
          }else if(err.resultCode==='9978'){
            this.hotList=[]
          }
          this.loading=false
        })
      }
    }, 300),
    SearchBtn(){
      this.GetTableList(0)
    },
    ChangeHotText(val){
      this.SearchValue=val.originalName
      this.GetTableList(1)
    },
    GetTableList(type){
      console.log(this.SearchValue)
      SearchComponent({
        name:this.SearchValue,
        c:type
      },this.apiHost).then(res=>{
        console.log(res)
        this.tableData=res.data.items
        if(res.data.items.length>0){
          this.CancelLocalData(this.SearchValue,res.data.items)
        }
      }).catch(err=>{
        if(err.resultCode==='6001'){
          this.$router.push({
            path:this.JumpPersonalCenter
          })
        }
      })
    },
    //local缓存
    CancelLocalData(val,list){
      const data=JSON.parse(localStorage.getItem('HistoricalQuery'))
      if(data){
          const index=data.findIndex(item=>item.name===val)
          console.log(index,'index')
          if(index<0){ //不存在重复
            if(data.length<3){
              data.push({
                name:val,
                list:list
              })
            }else{
              data.shift()
              data.push({
                name:val,
                list:list
              })
            }
          }else{
            data.splice(index,1)
            data.push({
              name:val,
              list:list
            })
          }
          console.log(data)
          localStorage.setItem('HistoricalQuery',JSON.stringify(data))
      }else{
        localStorage.setItem('HistoricalQuery',JSON.stringify([
          {
            name:val,
            list:list
          }
        ]))
      }
      this.GetHistoryList()
    },
    //获取历史搜索数据
    GetHistoryList(){
      let data=JSON.parse(localStorage.getItem('HistoricalQuery'))
      if(data){
        this.HistoryList=data.reverse()
      }
    },
    //点击历史查询获取缓存数据
    GetLocalHistoryData(item){
      this.SearchValue=item.name
      this.tableData=item.list
    }
  }
}
</script>

<style scoped lang="scss">
.name_query{
  display: flex;
  flex-direction: column;
  align-items: center;
  .query_title{
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-bottom: 42px;
  }
  .query_content{
    display: flex;
    .search_btn{
      width: 120px;
      height: 45px;
      background: #CA4300;
      border-radius: 0 5px 5px 0;
      border-left: none;
      color: #FFFFFF;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }
  }
  .query_history{
    display: flex;
    width: 640px;
    margin-left: 25px;
    margin-top: 21px;
    .history_title{
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      width: 80px;
    }
    .history_box{
      display: flex;
      flex-wrap: wrap;
      .his_word{
        height: 20px;
        background: #DDDDDD;
        margin-right: 8px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
        padding: 0 6px;
        margin-bottom: 10px;
      }
    }
  }
  .query_table{
    width: 860px;
    height: auto;
    background: #F6F6F6;
    margin-top: 20px;
    border: 1px solid #D2D2D2;
  }
}
::v-deep .el-select .el-input.is-focus .el-input__inner{
  border-color: #CA4300;
  border-radius: 5px 0 0 5px;
  height: 45px;
  border-right: none;
}
::v-deep .el-input__inner{
  border-radius: 5px 0 0 5px;
  height: 45px;
  border-right: none;
}
::v-deep .el-table__header-wrapper thead tr th .cell{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #878787;
  border-right: 1px solid #D2D2D2;
}
::v-deep .el-table__header-wrapper thead tr th:last-child .cell{
  border-right: none;
}
::v-deep .el-table__body-wrapper tr  td.el-table__cell{
  border-bottom: none;
}
</style>